import { INR, USD } from "constants/currency";
import { EN_US, EN_IN } from "constants/javaLocales";

export const CURRENCY_CODE_COUNTRY_CODE_MAP: Record<string, string[]> = {
  [USD]: [EN_US],
  [INR]: [EN_IN],
};

export const currency = ({
  amount,
  currencyCode,
  maximumFractionDigits = 2,
}: {
  amount: string | number;
  currencyCode?: string | null;
  maximumFractionDigits?: number;
}) => {
  // accounts without a currency (e.g. Stripe) send null, which Intl rejects
  const code = currencyCode || USD;
  return new Intl.NumberFormat(CURRENCY_CODE_COUNTRY_CODE_MAP[code] || EN_US, {
    style: "currency",
    currency: code,
    maximumFractionDigits: maximumFractionDigits,
  }).format(Number(amount));
};
